<!-- Footer -->
<div class="footer-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a routerLink="/"><img src="assets/img/logo-vertical.png" alt="image"></a>
                    </div>
                    <p>Our core business is to help customers achieve their business objectives by providing innovative,
                        best-in-class IT
                        consulting, IT solutions and services.</p>
                    <ul class="social">
                        <li><a href="#" class="facebook" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" class="twitter" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" class="pinterest" target="_blank"><i class='bx bxl-pinterest-alt'></i></a></li>
                        <li><a href="#" class="linkedin" target="_blank"><i class='bx bxl-instagram-alt'></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Important Links</h3>

                    <ul class="quick-links">
                        <li><a routerLink="/about-microsynctechnologies">About</a></li>
                        <li><a routerLink="/contact-us">Contact Us</a></li>
                        <li><a routerLink="/industries">Industries</a></li>
                        <li><a routerLink="/technology-expertise">Expertise</a></li>
                        <li><a routerLink="/faq">FAQ</a></li>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Featured Services</h3>

                    <ul class="quick-links">
                        <li><a routerLink="/testing-services">Testing</a></li>
                        <li><a routerLink="/development-services">Development</a></li>
                        <li><a routerLink="/resource-management-services">Resource Management</a></li>
                        <li><a routerLink="/data-analytics-services">Data & Analytics</a></li>
                        <li><a routerLink="/application-management-services">Application Management</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Information</h3>

                    <ul class="footer-contact-info">
                        <li>
                            <i class="flaticon-call"></i>
                            <span>Phone</span>
                            <a href="tel:{{env.phone}}">{{env.phone}}</a>
                        </li>
                        <li>
                            <i class="flaticon-email-1"></i>
                            <span>Email</span>
                            <a href="mailto:{{env.email}}">{{env.email}}</a>
                        </li>
                        <li>
                            <i class="flaticon-pin"></i>
                            <span>Address</span>
                            <a href="https://www.google.com/maps/@51.5287718,-0.2416804,11z"
                                target="_blank">{{env.location}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Footer -->

<!-- Copyright -->
<div class="copyright-area">
    <div class="container">
        <div class="copyright-area-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p>Copyright microsynctechnologies</p>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/terms-of-service">Terms of Service</a></li>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Copyright -->

<!-- Go Top -->
<div class="go-top">
    <i class='bx bx-chevron-up'></i>
</div>
<!-- End Go Top -->